import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ISimpleToggle {
  option1: string;
  option2: string;
  setState: (isOption1Select: boolean) => void;
  isOption2?: boolean;
  alignment?: string;
  width?: string;
}

export const SimpleToggle = (props: ISimpleToggle) => {
  const isDesktop = useIsDesktop();

  const toggleChangeHandler = (
    event: React.MouseEvent<HTMLElement>,
    toggleValue: string,
  ) => {
    if (toggleValue === null) return;
    props.setState(toggleValue === props.option1);
  };

  return (
    <ToggleButtonGroup
      value={props.alignment}
      exclusive
      onChange={toggleChangeHandler}
      sx={{
        bgcolor: '#fff',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '6px',
        width: props.width ? props.width : '100%',
        minWidth: isDesktop ? '400px' : undefined,
        label: {
          fontSize: '18px',
          fontWeight: '400',
          cursor: 'pointer',
        },
        '&&& .Mui-selected': {
          bgcolor: 'purple2.main',
          color: 'white',
          fontWeight: 700,
        },
        direction: 'rtl',
      }}
      role='tabpanel'
    >
      <ToggleButton
        value={props.option1}
        sx={{
          width: '100%',
          borderRadius: '0 6px 6px 0 !important',
          border: 'none',
          '&:focus': {
            bgcolor: '#081E54 !important',
            color: 'white',
          },
        }}
        role='tab'
        aria-selected={props.alignment === props.option1}
        aria-pressed={undefined}
      >
        <Typography variant={'body3'}>{props.option1}</Typography>
      </ToggleButton>
      <ToggleButton
        value={props.option2}
        sx={{
          width: '100%',
          borderRadius: '6px 0 0 6px !important',
          border: 'none !important',
          borderRight: '1px solid !important',
          '&:focus': {
            bgcolor: '#081E54 !important',
            color: 'white',
          },
          ml: '0px !important',
          mr: '-1px',
        }}
        role='tab'
        aria-selected={props.alignment === props.option2}
        aria-pressed={undefined}
      >
        <Typography variant={'body3'}>{props.option2}</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
